// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type Returns40Props = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const Returns40: FC<Returns40Props> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="40"
            height="41"
        >
            <path d="M11.083 32.076v-2.778H23.64c1.88 0 3.502-.616 4.868-1.847 1.366-1.232 2.048-2.764 2.048-4.597 0-1.834-.682-3.366-2.048-4.598-1.366-1.231-2.989-1.847-4.868-1.847H11.945l4.61 4.611-1.944 1.945-7.944-7.944 7.944-7.945 1.944 1.945-4.61 4.61H23.61c2.657 0 4.942.885 6.854 2.653 1.912 1.769 2.868 3.959 2.868 6.57s-.956 4.8-2.868 6.569c-1.912 1.769-4.197 2.653-6.854 2.653H11.083Z" />
        </svg>
    );
};

export default Returns40;
